export const MAX_CHANNEL_START_LIST_COUNT: number = 10;
